module.exports = __webpack_public_path__ + "static/media/tania_santos.209db06c.jpg";